import React from "react";
import "./Taxcalculation.css";
import TaxCalculationDashboard from "../components/TaxCalculationDashboard";

const Taxcalculation = () => {
  return <TaxCalculationDashboard />;
};

export default Taxcalculation;



